import { Instagram } from "lucide-react";
import AnimatedSection from "@/components/AnimatedSection";
import { useEffect, useRef } from "react";

export default function SocialMediaSection() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Load the EmbedSocial script once
    if (!document.getElementById("EmbedSocialHashtagScript")) {
      const script = document.createElement("script");
      script.id = "EmbedSocialHashtagScript";
      script.src = "https://embedsocial.com/cdn/ht.js";
      document.head.appendChild(script);
    }
  }, []);

  return (
    <section className="py-24 bg-[#f8f9fa] border-t border-border/50">
      <AnimatedSection className="container mx-auto px-4 max-w-7xl text-center space-y-12">
        <div className="space-y-4">
          <h2 className="text-4xl font-display font-bold text-primary uppercase">
            FOLLOW OUR JOURNEY
          </h2>
          <p className="text-primary/60 font-medium text-lg">
            See what we're up to on Instagram
          </p>
        </div>

        {/* EmbedSocial Live Instagram Widget */}
        <div ref={containerRef}>
          <div
            className="embedsocial-hashtag"
            data-ref="9de7895c1294688166db97ff1ae531944582c042"
            data-lazyload="yes"
          ></div>
        </div>

        <div className="flex justify-center pt-8">
          <a
            href="https://www.instagram.com/wagrightdogs"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-primary font-bold uppercase tracking-widest text-sm hover:text-accent transition-colors"
          >
            <Instagram className="w-5 h-5" /> @wagrightdogs
          </a>
        </div>
      </AnimatedSection>
    </section>
  );
}
